// Cálculos puros usados pelo cartão de Overview (NPS/CES/CSAT/Jornada),
// extraídos de index.jsx para serem testados sem montar o componente/redux.

const ZONE_LABELS = [
  { l: "Crítico", r: "-100 a -1", c: "#f97316", left: 0 },
  { l: "Aperfeiçoamento", r: "0 a 49", c: "#a3e635", left: 50 },
  { l: "Qualidade", r: "50 a 74", c: "#4ade80", left: 75 },
  { l: "Excelência", r: "75 a 100", c: "#166534", left: 87.5 },
];

// Zona do NPS na escala de -100 a 100 (igual ao Net Promoter Score clássico).
export function npsZoneAtual(nps) {
  if (nps < 0) return "Crítico";
  if (nps < 50) return "Aperfeiçoamento";
  if (nps < 75) return "Qualidade";
  return "Excelência";
}

// Posição (%) do ponteiro na barra de escala, que vai de -100 a 100.
export function npsScalePct(nps) {
  return ((nps + 100) / 200) * 100;
}

export function npsZoneLabels() {
  return ZONE_LABELS;
}

// Progresso (%) da Jornada CX rumo à meta, limitado a 100% (não "estoura" a barra
// quando o valor atual já superou a meta).
export function jornadaProgressPct(jornadaCX, jornadaMeta) {
  if (!jornadaMeta) return 0;
  return Math.min(100, Math.round((jornadaCX / jornadaMeta) * 100));
}
